/**
 * Validates and rewrites the input value to allow only numeric values up to 10 digits.
 */

export const validateNumericInput = (
  value: string,
  charLimit: number,
): string => {
  // Remove all non-numeric characters and limit to 10 digits
  return value.replace(/[^0-9]/g, "").substring(0, charLimit);
};

export const validateStringInput = (
  value: string,
  charLimit: number,
): string => {
  return value.substring(0, charLimit);
};

/**
 * Year-specific utilities
 */
export const sanitizeYearInput = (value: string): string => {
  // keep only digits and limit to 4 characters (YYYY)
  return value.replace(/[^0-9]/g, "").slice(0, 4);
};

export const isValidYear = (value: string | number): boolean => {
  if (value === null || value === undefined) return false;
  const num = typeof value === "string" ? Number(value) : value;
  if (!Number.isFinite(num)) return false;
  // valid year between 1900 and 9999
  return num >= 1900 && num <= 9999;
};
